import { BoxMaintenanceApi } from "./api.box";
import { CloudMaintenanceApi } from "./api.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseMaintenanceApi } from "./api.base";
import environment from "@/config";

export default getService<BaseMaintenanceApi>(environment.nexus, {
    box: new BoxMaintenanceApi(),
    cloud: new CloudMaintenanceApi(),
});